import React from 'react';

export const TopList = ({ title, rows, testid }) => {
  const max = Math.max(1, ...rows.map((r) => r.count));
  return (
    <div className="bg-white border rounded-xl p-4" data-testid={testid}>
      <p className="font-semibold text-gray-900 mb-3">{title}</p>
      {rows.length === 0 ? (
        <p className="text-sm text-gray-400 py-6 text-center">No data for this period</p>
      ) : (
        <div className="space-y-2.5">
          {rows.map((r) => (
            <div key={r.label}>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-700 truncate pr-2">{r.label}</span>
                <span className="font-semibold text-gray-900 tabular-nums">{r.count.toLocaleString('en-CA')}</span>
              </div>
              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div className="h-full bg-[#1a5c3b] rounded-full transition-[width] duration-500" style={{ width: `${(r.count / max) * 100}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
